import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import { handleApiErrorWithReauth } from '@/lib/api/reauth';

import type { MfaSettingsReq } from './type';

export const getMfaSettings = async () => {
  const res = await apiClient.GET('/v2/settings/mfa');
  return getDataOrThrowApiError(res);
};

// @SecureApi(PATCH /v2/settings/mfa/email): AAL2 未充足時は 401+code が返るため、
// handleApiErrorWithReauth で再認証→元操作の再実行をラップする。
export const updateMfa = async (requestData: MfaSettingsReq) =>
  handleApiErrorWithReauth(async () => {
    const res = await apiClient.PATCH('/v2/settings/mfa/email', {
      body: requestData,
    });
    return getDataOrThrowApiError(res);
  });
